import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const getRoleList = async () => {
    const data = await apiCall("post", apiEndPoints.GETROLE);
        return data;
};

const createRole = async (params) => {
    const data = await apiCall("post", apiEndPoints.CREATEROLE,params);
        return data;
};
const roleDetail = async (params) => {
    const data = await apiCall("post", apiEndPoints.GETROLE,params);
        return data;
};


const roleService = {
    getRoleList,
    createRole,
    roleDetail,
  };
  
  export default roleService;

